import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import {
  NotificationTripBooking,
  NotificationResponse,
  NotificationWandaPlus,
  NotificationWandaBasic,
  NotificationServiceUserAdded,
  NotificationSubscriptionRefund,
  NotificationTripRefund,
} from "../types/EmailNotificationType";
const appSettings = AppSettingsService;

export async function sendEmailWandaPlusSubscription(
  data: NotificationWandaPlus
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendEmailBookingCancel(
  data: NotificationTripBooking
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendEmailWandaPlusDowngrade(
  data: NotificationWandaBasic
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendEmailServiceUserAdded(
  data: NotificationServiceUserAdded
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendEmailTripRefund(
  data: NotificationTripRefund
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function sendEmailSubscriptionRefund(
  data: NotificationSubscriptionRefund
): Promise<NotificationResponse> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/communications/Event/v1/ProcessByEventId`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}
